import React from "react";
import { Text } from "@chakra-ui/react";
import moment from "moment";
import { useAtom } from "jotai";
import { DateFormatAtom } from "../../../store/AppStateAtom";
import { formatDate } from "../../../utils/DateUtils";

export const DateColumn = (props: any) => {
  const [dateFormat] = useAtom(DateFormatAtom);

  if (!props.value) return null;

  // Check if the date has a time component or is just a date
  const isDateOnly =
    props.dateOnly === true ||
    moment(props.value, "YYYY-MM-DDThh:mm:ss").toString().includes("00:00:00");

  return <Text>{formatDate(props.value, dateFormat, !isDateOnly)}</Text>;
};
